import { createSelector } from '@reduxjs/toolkit'

export const authSelector = createSelector(
  state => state.auth,
  auth => auth
)

export const accessTokenSelector = createSelector(
  authSelector,
  auth => auth?.accessToken
);

export const currentUserDetailsSelector = createSelector(
  authSelector,
  auth => auth?.user
);

export const currentUserEmailSelector = createSelector(
  currentUserDetailsSelector,
  user => user?.email
);

export const isUserAuthenticatedSelector = createSelector(
  accessTokenSelector,
  accessToken => !!(accessToken)
);


const compareName = (a, b) => {
  if (a.name < b.name) { return -1; }
  if (a.name > b.name) { return 1; }
  return 0;
};

export function getAuthRole(auth) {
  let authRole = null;

  if (auth &&
    auth.session &&
    auth.session.user) {
    const permissions = auth.session.user.role.permissions.sort(compareName);
    authRole = { ...auth.session.user.role, permissions };
  }
  return authRole;
}



